<template>
  <div class="favourites_block_holder">
    <div id="menu" class="favourites">
      <div class="modal-body">
        <div class="menu_bottom">
          <div id="raceselection">
            <a v-for="race in event.races" @click="toggleRace(race.id)">
              <span id="race_name">{{race.name}}</span><br>
            </a>
          </div>
          <br>
          <div class=""><a @click="externalHTTP" id="about">ABOUT THE RACE</a></div>
          <!-- <div class="">SPONSORS</div> -->
          <div class="disclaimers">
            <div><a href="https://www.sportraxs.com/privacy" >PRIVACY POLICY</a></div>
            <div><a href="https://www.sportraxs.com/tos" >TERMS & CONDITIONS</a></div>
          </div>
        </div>
      </div>
      <div class="modal-footer footer_sponsor">
        <div class="col-xs-4 col-xs-offset-2 poweredby">Powered by</div><div class="col-xs-4 nopadding"><img src="https://d3nv7i3620sxr0.cloudfront.net/img/sportraxs_logo.png" class="img-responsive"></div>
      </div>
    </div>
  </div>
</template>
<style>

</style>
<script>
import { mapGetters } from 'vuex'

export default{
  data: function () {
    return {
      selectedCat: 'All Categories'
    }
  },
  mounted () {
    console.log()
  },
  methods: {
    toggleRace: function (raceId) {
      this.$store.dispatch('loadRace', raceId)
      this.$router.push({name: 'map', params: {raceId: raceId}})
    },
    externalHTTP () {
      window.location.href = this.races[0].website
    }
  },
  computed: {
    ...mapGetters({
      mobile: 'mobile',
      event: 'event',
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menu.vue